export default "/assets/saved-3fd459dd989aff3429ffad96c38cc0d2e69bdd963c2c8655fdeb4546101b13d1.svg";